import React from "react";
import {PageTitle} from "../../Components/Landmarks";
import {locations} from "../../Utilities/Location";
import {allow, policyEvents} from "../../Components/Authorize";
import {DashboardTile} from "./DashboardTile";
import { GridContainer} from "../../Components/Grid";
import {LayoutFullBleed} from "../../Components/Layout";
import { isAdmin } from "@/Utilities/LocalStorage/storageUtilities";




export const DashboardContainer: React.FC = () => {
    const canManageLoanLibraryLoans = allow(policyEvents.MANAGE_LOAN_LIBRARY_LOANS);
    const canManageOwnLoans = allow(policyEvents.MANAGE_OWN_LOANS);
    const canManageResources = canManageLoanLibraryLoans || canManageOwnLoans;

    const canAdminUsers = allow(policyEvents.APPROVE_USERS);
    const canAdminReports = allow(policyEvents.ADVANCE_SEARCH);
    const canAdministrate =  canAdminUsers || canAdminReports;

    return (
        <>
 

            <LayoutFullBleed className={`catalog catalog--dashboard`}>
                <PageTitle h1={isAdmin() ? "Admin Dashboard" : "Dashboard"} className={`dashboard-title`}/>    

                <header>
                    <h2>Resources</h2>
                </header>
                <GridContainer hasMarginX hasMarginY className={`dashboard`}>
                    <DashboardTile
                        {...locations.LIBRARY_LOAN.link}
                        description={"Search, view, update"}
                        iconName="Loan-Library"
                    />

                    <DashboardTile
                        {...locations.OWN_CATALOG.link}
                        description={"Search, view, update"}
                        iconName="Own-Catalog"
                        label="Own Library"
                    />
                </GridContainer>
                <br/>
                <br/>

                {
                    canManageResources &&
                    <>
                        <header>
                            <h2>Requested Resources</h2>
                        </header>
                        <GridContainer hasMarginX hasMarginY className={`dashboard`}>
                            {canManageLoanLibraryLoans &&
                                <DashboardTile
                                    {...locations.LOAN_LIBRARY_LOAN_MANAGEMENT.getLink()}
                                    description={"Search, view, update"}
                                    iconName="Loan-Management"
                                />
                            }
                            {canManageOwnLoans &&
                                <DashboardTile
                                    {...locations.OWN_LOAN_MANAGEMENT.link}
                                    description={"Search, view, update"}
                                    iconName="Own-Loan-Management"
                                    label="Own Library Management"
                                />
                            }
                        </GridContainer>
                        <br/>
                        <br/>
                    </>
                }
              
                {
                    canAdministrate &&
                    <>
                        <header>
                            <h2>Administration</h2>
                        </header>
                        <GridContainer hasMarginX hasMarginY className={`dashboard`}>
                           
                            {
                                canAdminUsers &&
                                <DashboardTile
                                    {...locations.USER_MANAGEMENT.link}
                                    description={"View and manage all users"}
                                    iconName="User-Management"
                                />
                            }
                            {
                                canAdminReports &&
                                <DashboardTile
                                    {...locations.REPORTS.link}
                                    description={"View reports"}
                                    iconName="Reports"
                                />
                            }
                        </GridContainer>
                        <br/>
                        <br/>
                    </>
                }
            </LayoutFullBleed>
        </>
    );
};
